import React, { Component } from 'react';
import { sendToMe } from '../../Utils/email';
import { toggleContact } from '../../state/actions/index'
import { connect } from 'react-redux';
import { Zoom } from 'react-reveal';
import { AsYouType } from 'libphonenumber-js';
import Joi from 'joi-browser';
import ButtonPrimary from '../ButtonPrimary';
import PropTypes from 'prop-types';
import style from './style.module.scss';
import { TweenMax } from 'gsap';

const schema = Joi.object().keys({
    string: Joi.string().min(1),
    phone: Joi.string().regex(/^[()0-9+-]*$/),
    email: Joi.string().email({ minDomainAtoms: 2 }),
});

class Contact extends Component {

    contactTypes = {
        bimbo: 'General',
        tourBimbo: 'Bimbo Tour',
        school: 'Bimbo Goes To School',
        tourHolsum: 'Holsum Tour'
    }

    state = {
        name: "",
        email: "",
        phone: "",
        message: "",
        disabled: true,
        validName: false,
        validEmail: false,
        validPhone: false,
        validMessage: false,
        errorLabelName: false,
        errorLabelPhone: false,
        errorLabelEmail: false,
        errorLabelMessage: false,
        open: false
    }

    setHeaderClassName = (type) => {
        const types = {
            bimbo: style.bimboHeader,
            tourBimbo: style.tourHeader,
            school: style.schoolHeader,
            tourHolsum: style.holsumHeader
        };
        return types[type];
    };

    onSend = (e) => {
        e.preventDefault()

        this.setState({
            disabled: true,
            name: "",
            email: "",
            phone: "",
            message: "",
        })

        // sendAuto(this.state.email, this.state.name).then((response) => {
        //     console.log("EMAIL SENT SUCCESSFULLY", response);
        // })
        sendToMe(this.state.message, this.state.email, this.state.name, this.state.phone, this.contactTypes[this.props.type]).then((response) => {
            this.props.dispatch(toggleContact(false));

            console.log("EMAIL SENT TO ME SUCCESSFULLY", response);
        })

    }

    onChange = ({ target }) => {
        let { name, value } = target;
        let { validEmail, validPhone, validMessage, validName } = this.state;
        // let phoneNumber = parsePhoneNumberFromString(`${this.state.phone}`, 'US');

        switch (name) {
            case "name":
                var err = Joi.validate({ string: value }, schema);
                if (err.error) {
                    this.setState({
                        validName: false,
                        errorLabelName: true,
                        disabled: true,
                        [name]: value
                    })
                } else {
                    console.log("valid name: ", this.state);
                    let disabled = true;
                    if (validEmail && validPhone && validMessage) {
                        disabled = false;
                    }
                    this.setState({
                        [name]: value,
                        validName: true,
                        errorLabelName: false,
                        disabled: disabled,
                        [name]: value
                    })
                }
                break;
            case "email":
                var err = Joi.validate({ email: value }, schema);

                if (err.error) {
                    this.setState({
                        validEmail: false,
                        errorLabelEmail: true,
                        disabled: true,
                        [name]: value
                    })
                } else {
                    console.log("Valid email: ", this.state);
                    let disabled = true;
                    if (validName && validPhone > 0 && validMessage) {
                        disabled = false;
                    }
                    this.setState({
                        validEmail: true,
                        errorLabelEmail: false,
                        disabled: disabled,
                        [name]: value
                    })
                }
                break;
            case "phone":
                let text = new AsYouType('US').input(value);
                if (value.length > this.state.phone.length) {
                    value = text
                }
                // // value = value.length > 3 ? text : value;
                // if (value.length === 3 && value.indexOf('(') === -1) {
                //     value = text;
                // } else if (value.length === 4 && value.indexOf('(') > -1) {
                //     value = value;
                // } else {
                //     value = text;
                // }

                if (value.length !== 14 && value.length !== 0) {
                    this.setState({
                        errorLabelPhone: true,
                        validPhone: false,
                        disabled: true,
                        [name]: value
                    }
                    )
                } else {
                    console.log("STATE ON PHONE CHANGE ", this.state)
                    let disabled = true;
                    if (validEmail && validMessage && validName) {
                        disabled = false;
                    }
                    console.log("valid Phone: ", this.state);
                    this.setState({
                        validPhone: true,
                        errorLabelPhone: false,
                        disabled: disabled,
                        [name]: value
                    })
                }
                break;
            case "message":
                var err = Joi.validate({ string: value }, schema);
                if (err.error) {
                    this.setState({
                        validMessage: false,
                        errorLabelMessage: true,
                        disabled: true,
                        [name]: value
                    })
                } else {
                    console.log("STATE ON MESSAGE CHANGE ", this.state)
                    console.log("valid Message: ", this.state);
                    let disabled = true;
                    if (validEmail && validPhone && validName) {
                        disabled = false;
                    }
                    this.setState({
                        validMessage: true,
                        errorLabelMessage: false,
                        disabled: disabled,
                        [name]: value
                    })
                }
                break;
            default:
                this.setState({
                    [name]: value
                })
                break;
        }
    }

    warningName() {
        return this.state.errorLabelName ? <span className={style.errorLabel}>Please enter a valid Name.</span> : null
    }

    warningPhone() {
        return this.state.errorLabelPhone ? <span className={style.errorLabel}>Please enter a valid phone number.</span> : null
    }

    warningEmail() {
        return this.state.errorLabelEmail ? <span className={style.errorLabel}>Please enter a valid Email.</span> : null
    }

    warningMessage() {
        return this.state.errorLabelMessage ? <span className={style.errorLabel}>Please enter a valid Message.</span> : null
    }

    setHeader() {
        switch (this.props.type) {
            case 'bimbo': return 'Contact Bimbo';
            case 'school': return 'Bimbo School Visit';
            case 'tourBimbo': return 'Tour Bimbo';
            case 'tourHolsum': return 'Tour Holsum';
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.contactOpen !== prevProps.contactOpen) {
            if (this.props.contactOpen) {
                this.setState({ open: true }, () => {
                    TweenMax.set(this.contactBoxRef, { opacity: 0 });
                    TweenMax.fromTo(this.contactBoxRef, 0.3, { y: 200, opacity: 0 }, { y: 0, opacity: 1 });
                })
            } else {
                var myAnimation = new TweenLite(this.contactBoxRef, 0.3, { y: 200, opacity: 0, onComplete: () => this.setState({ open: false }) });
            }
        }
    }

    render() {
        return this.state.open ? (
            <div className={style.contactWrapper}>
                <div ref={r => this.contactBoxRef = r} className={style.all}>
                    <div className={`${style.headerWrapper} ${this.setHeaderClassName(this.props.type)}`}>
                        <div className={`${style.headerSection} ${style.imageWrapper}`}>
                            <Zoom left>
                                <img src={this.props.logo}></img>
                            </Zoom>
                        </div>
                        <div className={`${style.headerSection} ${style.labelWrapper}`}>
                            <span className={style.header}>{this.setHeader()}</span>
                        </div>
                        <div className={`${style.headerSection} ${style.iconWrapper}`}>
                            <i onClick={(e) => this.props.dispatch(toggleContact(false))} className={`material-icons ${style.close}`}>clear</i>
                        </div>
                    </div>
                    <div className={style.contentWrapper}>
                        <div className={style.flexWrapper}>
                            <form className={style.form}>
                                <div className={style.inputGroup}>
                                    <label>{this.warningName()}</label>
                                    <input onChange={this.onChange} name="name" value={this.state.name} className={style.input} type="text" placeholder="Name" />
                                </div>
                                <div className={style.inputGroup}>
                                    <label>
                                        {this.warningEmail()}
                                    </label>
                                    <input onChange={this.onChange} name="email" value={this.state.email} className={style.input} type="text" placeholder="Email" />
                                </div>
                                <div className={style.inputGroup}>
                                    <label> {this.warningPhone()}</label>
                                    <input onChange={this.onChange} name="phone" value={this.state.phone} className={style.input} type="text" placeholder="Phone" />
                                </div>
                                <div className={style.inputGroup}>
                                    <label> {this.warningMessage()}</label>
                                    <textarea onChange={this.onChange} name="message" value={this.state.message} className={style.textArea} type="text" placeholder="Write a message..." />
                                </div>
                            </form>
                        </div>
                        <ButtonPrimary label="SUBMIT" size='medium' onClick={this.onSend} disabled={this.state.disabled}>
                            Submit
                        </ButtonPrimary>
                    </div>
                </div>
            </div >
        ) : null
    }
}

Contact.defaultProps = {
    title: "CONTACT BIMBO",
    headerbackgroundColor: "blue",
    type: 'bimbo',
    logo: null
}

Contact.propTypes = {
    title: PropTypes.string,
    background: PropTypes.string,
    logo: PropTypes.string,
    classes: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.string,
    ]),
    type: PropTypes.oneOf([
        'bimbo',
        'tourBimbo',
        'school',
        'tourHolsum',
    ]),
};


export default connect((state) => {
    return {
        type: state.contactType,
        contactOpen: state.contactOpen
    }
})(Contact)